<script lang="ts">
  import { _ } from 'svelte-i18n';

  import IndustryTree from '$lib/components/IndustryTree.svelte';
  import { scheduleCount } from '$lib/stores/guided';

  /**
   * Which industries to search in.
   *
   * The tree itself is shared with the data-selection popup — see
   * IndustryTree, which also explains why the counts are companies rather than
   * contacts. All this step adds is the running total: every change re-asks
   * how large the selection now is.
   *
   * The panel is capped in height here because it sits in a column of steps
   * with a count bar and the buttons beneath it, which the popup does not have.
   */
</script>

<div class="max-h-[46vh] overflow-y-auto">
  <IndustryTree onChange={scheduleCount} />
</div>
